export const errorsMixin = {
    methods: {
        handleError(error) {
            if (error.response.status === 422) {
                this.validationErrors = error.response.data.errors;
            }
            alert(error.response.data.message);
        },
    }
    }